import { render, staticRenderFns } from "./IncentivesDetails.vue?vue&type=template&id=642407da"
import script from "./IncentivesDetails.vue?vue&type=script&lang=js"
export * from "./IncentivesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports